import React from "react"

import AccessContent from "@/components/admin/AccessContent"
import AdminPage from "@/components/admin/AdminPage"

const Access: React.FC = () => (
  <AdminPage>
    <AccessContent />
  </AdminPage>
)

export default Access
